import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapePinLeft extends Shape {
    defaultBorderWidth = 12;
    defaultColor = "transparent";
    fillStyleEnabled = false;
    includeText = false;

    setDrawStyle(_: any): void {}

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.save();
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.stroke();
        canv.ctx.closePath();

        canv.ctx.beginPath();
        canv.ctx.lineCap = "round";

        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.75, y + h * 0.5);

        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.45, y + h * 0.3);

        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.45, y + h * 0.7);

        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round" d="M17.15 12.02h-9.1m0 0 2.79-3.82m-2.8 3.82 2.8 4.1M22 2H2v20h20V2Z"/>
            </svg>
        `;
    }
}
